import React from "react";
import CountrySection from "./CountrySection";
import StateSection from "./StateSection";
import CitySection from "./CitySection";
import StreamSection from "./StreamSection";
import CourseSection from "./CourseSection";
import SpecializationSection from "./Specializations";

const SelectedFilterPopup = ({
  filterData,
  selectedFilterCategory,
  setSelectedFilterCategory,
  filterOptions,
  collegesUrl,
  location,
  filterSecStreamData,
  availableStreams,
  filterSpecialization,
  handleModalToggle,
}: any) => {

  return (
    <div>
      {selectedFilterCategory === "country" && (
        <CountrySection
          filterData={filterData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          handleModalToggle={handleModalToggle}
        />
      )}
      {selectedFilterCategory === "state" && (
        <StateSection
          filterData={filterData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          collegesUrl={collegesUrl}
          location={location}
          handleModalToggle={handleModalToggle}
        />
      )}
      {selectedFilterCategory === "city" && (
        <CitySection
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterOptions={filterOptions}
          location={location}
          filterData={filterData}
          collegesUrl={collegesUrl}
          handleModalToggle={handleModalToggle}
        />
      )}
      {selectedFilterCategory === "stream" && (
        <StreamSection
          setSelectedFilterCategory={setSelectedFilterCategory}
          availableStreams={availableStreams}
          filterOptions={filterOptions}
          filterSecStreamData={filterSecStreamData}
          handleModalToggle={handleModalToggle}
        />
      )}
      {selectedFilterCategory === "course" && (
        <CourseSection
          filterData={filterData}
          filterOptions={filterOptions}
          filterSecStreamData={filterSecStreamData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          handleModalToggle={handleModalToggle}
        />
      )}
      {selectedFilterCategory === "specialization" && (
        <SpecializationSection
          filterData={filterData}
          setSelectedFilterCategory={setSelectedFilterCategory}
          filterSecStreamData={filterSecStreamData}
          filterOptions={filterOptions}
          filterSpecialization={filterSpecialization}
        />
      )}
    </div>
  );
};

export default SelectedFilterPopup;
